<section class="container-fluid">
    <div class="content">
        <app-breadcrumb [s_breadcrumb]="'Reference'">
        </app-breadcrumb>
    </div>
</section>